<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render';

const props = defineProps<{
  themeKeys: {
    bgBottom: string;
    fgBottom: string;
  };
}>();

const lang = useLocalStorage('CONTENT_LANG', 'en');

const { data: dataQueried } = await useAsyncData('content-footer-data', () =>
  queryCollection('footer').all(),
);
const data = computed(() =>
  dataQueried.value?.find(
    (item) => item.title.toLowerCase() === lang.value?.toLowerCase(),
  ),
);
</script>

<template>
  <div v-if="data">
    <div
      class="px-4 py-4 md:px-8 md:py-8 xl:px-32 xl:py-24;"
      :style="{
        backgroundColor: props.themeKeys.bgBottom,
        color: props.themeKeys.fgBottom,
      }"
    >
      <div class="inner-container relative">
        <div class="flex flex-col md:flex-row gap-4 md:gap-12">
          <div class="w-full md:w-1/2">
            <h4 class="text-2xl mb-2">{{ data.moreInfo.title }}</h4>
            <p class="mb-2">{{ data.moreInfo.text }}</p>
            <div class="hidden md:flex flex-row flex-wrap gap-x-4 gap-y-2 text-sm">
              <a
                v-for="link in Object.values(data.importantLinks)"
                :key="link.text"
                :href="link.link"
                class="cursor-pointer hover:underline"
              >
                {{ link.text }}
              </a>
            </div>
          </div>
        </div>
        <p class="text-xs mt-4">{{ data.copyRight }}</p>
        <UButton
          class="absolute m-4 bottom-0 right-0"
          variant="solid"
          color="neutral"
          size="xl"
          :to="data.formLink.link"
          external
          target="_blank"
        >
          {{ data.formLink.text }}
        </UButton>
      </div>
    </div>
  </div>
</template>
